import {
    GuxFormFieldCheckbox,
    GuxIcon,
    GuxTooltip,
} from "genesys-spark-components-react";
import { ReadOnlyCheckbox } from "features/common/ReadOnlyInput";
import { AiAnswerExplanation } from "./AiScoringMCQOption";
import { useAppSelector } from "app/hooks";
import { selectCanUserViewAiScoringExplanation } from "features/auth/currentUserSlice";
import { useStrings } from "features/i18n/useStrings";
import strings from "../../common/questionComponents/CommonQuestionComponents.strings";
import aiScoringStringsModule from "./AiScoringMCQOption.strings";
import "./AiScoringNAOption.less";

export function AiScoringNAOption({
    checked,
    disabled,
    onChange,
    explanation,
}: {
    checked: boolean;
    disabled: boolean;
    onChange: () => void;
    explanation: string;
}) {
    const t = useStrings(strings);
    const aiScoringStrings = useStrings(aiScoringStringsModule);
    const canViewAiScoringExplanation = useAppSelector(
        selectCanUserViewAiScoringExplanation
    );

    return (
        <>
            <div className="ai-scoring-icon" data-testid="ai-scoring-icon">
                <GuxIcon
                    iconName="restricted/custom/sparkles-solid"
                    screenreader-text={t.labels.aiSuggestedAnswer}
                />
                <GuxTooltip>{t.labels.aiSuggestedAnswer}</GuxTooltip>
            </div>
            <div className="AiScoringNAOption">
                <div className="NAOption">
                    {disabled ? (
                        <ReadOnlyCheckbox
                            checked={checked}
                            label={t.labels.na}
                        />
                    ) : (
                        <GuxFormFieldCheckbox>
                            <input
                                slot="input"
                                type="checkbox"
                                name={t.labels.na}
                                checked={checked}
                                onChange={onChange}
                                className="Clickable"
                            />
                            <label className="Clickable" slot="label">
                                {t.labels.na}
                            </label>
                        </GuxFormFieldCheckbox>
                    )}
                    <div className="ai-answer-details">
                        <div
                            className="ai-suggested"
                            data-testid="ai-suggested-tag"
                        >
                            <span>{aiScoringStrings.labels.aiSuggested}</span>
                        </div>
                    </div>
                </div>
                {canViewAiScoringExplanation && (
                    <AiAnswerExplanation explanation={explanation} />
                )}
            </div>
        </>
    );
}
